import { Component, Input, ContentChild, TemplateRef, HostBinding } from '@angular/core';

@Component({
    selector: 'agpr-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: false
})
export class TabComponent {
    @Input() id: string;
    @Input() icon: string;
    @Input() heading: string;
    @Input() description: string;
    @Input() tooltip: string;
    @Input() disabled: boolean = false;
    @Input() hidden: boolean = false;
    @Input() showSpacer: boolean = false;
    @Input() showSpacerAfter: boolean = false;
    @Input() hideTabShowContent: boolean = false;
    @Input() numberDescription?: string = '';
    @Input() tabTitle?: string = '';
    @Input() useNumberWithIcon: boolean = false;
    @Input() headerIcon: string;
    @Input() headerIconTooltip: string;
    protected _header: TemplateRef<any>;
    @ContentChild('tabHeader') set header(value: TemplateRef<any>){
        this._header = value;
    }
    get header(){
        return this._header;
    }

    @ContentChild('tabFooter') public footer: TemplateRef<any>;
    @ContentChild('extendedContent') public extendedContent: TemplateRef<any>;

    @HostBinding('style.display')
    get hostDisplay(): string | null {
        return this.selected && !this.hidden ? null : 'none';
    }

    selected: boolean = false;
    focused: boolean;
    iconState: any;
    touched: boolean = false;
    error: boolean = false;
    stateAriaLabel: string;
}
